import PlaceModel1CircAvaiable from "../../../../../assets/FloorPlanAssets/place_model-1_circle_available.svg";
import PlaceModel1CircDisabled from "../../../../../assets/FloorPlanAssets/place_model-1_circle_disabled.svg";
import PlaceModel1CircOccupied from "../../../../../assets/FloorPlanAssets/place_model-1_circle_occupied.svg";
import PlaceModel1CircTemp from "../../../../../assets/FloorPlanAssets/place_model-1_circle_temp.svg";
import PlaceModel1CircForbidden from "../../../../../assets/FloorPlanAssets/place_model-1_circle_forbidden.svg";
import PlaceModel2RectPark from "../../../../../assets/FloorPlanAssets/place_model-2_rect_park.svg";
import PlaceModel2RectElec from "../../../../../assets/FloorPlanAssets/place_model-2_rect_elec.svg";
import PlaceModel2RectParkColleague from "../../../../../assets/FloorPlanAssets/place_model-2_rect_park_colleague.svg";
import PlaceModel2RectElecColleague from "../../../../../assets/FloorPlanAssets/place_model-2_rect_elec_colleague.svg";

// workplace rectangle sprite
export { default as WorkplaceRect } from "../../../../../assets/FloorPlanAssets/place_model-1_rect.svg";
// workplace rectangle sprite for colleague booking
export { default as WorkplaceRectForColleague } from "../../../../../assets/FloorPlanAssets/place_model-1_rect_colleague.svg";

// place circle sprite
export const PlaceCircle = {
  Available: PlaceModel1CircAvaiable,
  Disabled: PlaceModel1CircDisabled,
  Occupied: PlaceModel1CircOccupied,
  Temp: PlaceModel1CircTemp,
  Forbidden: PlaceModel1CircForbidden
};

// park place circle sprite but the circle is shared with place circle
export { default as ParkplCirc } from "../../../../../assets/FloorPlanAssets/place_model-2_circle.svg";

// park place rectangle sprite
export const ParkPlaceRect = {
  Parking: PlaceModel2RectPark,
  ElectricCharging: PlaceModel2RectElec,
  ParkingColleague: PlaceModel2RectParkColleague,
  ElectricChargingColleague: PlaceModel2RectElecColleague
};

// park place P icon text as svg image
export { default as ParkPlaceIcon } from "../../../../../assets/FloorPlanAssets/place_model-2_icon_park.svg";
